export function replaceString(value: string): string {
  return value.replace(/\D/g, '')
}

export function replaceEmptySpacesWithUnderline(value: string): string {
  return value?.toUpperCase()?.replaceAll(' ', '_')
}

export function replaceUnderscoreWithEmptySpace(value: string): string {
  return value
    ?.toLowerCase()
    ?.replaceAll('_', ' ')
    ?.replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()))
}

export function replaceUnderscoreAndFormatSentence(value: string): string {
  if (!value) return ''

  const formatted = value?.toLowerCase()?.replaceAll('_', ' ')
  return formatted?.charAt(0)?.toUpperCase() + formatted?.slice(1)
}
